<nb-card>
  <nb-card-header>Cambiar Contraseña</nb-card-header>
  <nb-card-body>
    <form [formGroup]="formData">
      <input type="password" nbInput fullWidth placeholder="Contraseña Actual" formControlName="lastPassword" required>
      <br />
      <input type="password" nbInput fullWidth placeholder="Nueva Contraseña" formControlName="newPassword" required>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton hero status="info" (click)="dismiss()">Cancelar</button>
    <button nbButton hero status="primary" (click)="save()">Cambiar</button>
  </nb-card-footer>
</nb-card>
